import './styles.css';


angular.module(module.exports = 'ttb.issue.workLogDetails.workLogEditor', [
    require('./work-log-editor.service'),
    require('./work-log-editor.component')
]);



// WEBPACK FOOTER //
// ./components/work-log-editor/index.js